import React, { useState, useCallback, useEffect } from "react";
import { Container, Content, Title, Field, Input, Label } from "./styles";

import {
  Modal,
  Button,
  Checkbox,
  Icon,
  Dropdown,
  Form,
  TextArea,
  Tab,
} from "semantic-ui-react";

import { producaov2 as api } from "../../../../../services/apis";
import { useDebounce } from "../../../../../hooks/useDebounce";

import swal from "sweetalert";

export default function SurveySelector({
  selectedSurveyID,
  onChangeSelectedSurveyID,
  ...props
}) {
  const [curso, setCurso] = useState("");
  const [cursosOptions, setCursosOptions] = useState([]);
  const [cursoSearch, setCursoSearch] = useState("");

  const [survey, setSurvey] = useState();
  const [surveyOptions, setSurveyOptions] = useState([]);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);

  const handleCursoChange = useCallback((e, { options, value }) => {
    const text = options?.find((option) => option.value === value)?.text || "";
    setCurso(value);
    setCursoSearch(text);

    if (props.handleChange) {
      if (props?.fullInfo) {
        const course = options?.find((option) => option.value === value);

        return props.handleChange(course);
      }

      props.handleChange(value);
    }
  }, []);

  const handleCursoSearchChange = useCallback((e) => {
    try {
      const search = e.target.value;

      setCursoSearch(search);

      api
        .get(`cursos-simplelist?search=${search}&limit=15`, {
          params: {
            excludeIDs: props?.excludeCourseIDs,
          },
        })
        .then((res) => {
          if (res.data.length > 0) {
            const options = res.data.map((course, index) => ({
              key: index,
              text: `[${course.id}] ${course.curso}`,
              value: course.id,
              type: course?.type,
              id: course?.id,
            }));
            setCursosOptions(options);
            return;
          }
          setCursosOptions([]);
        });
    } catch (err) {
      console.error(err);

      setCursosOptions([]);
    }
  });

  const handleChangeSearch = (search) => {
    console.log("SEARCH => ", search);
    setSearch(search);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await api.get("/admin/dropdown-survey", {
          params: {
            search,
          },
          headers: {
            access_token: `voitto-token ${localStorage.getItem("oauth_token")}`,
          },
        });

        setSurveyOptions(
          response.data.data.map((survey) => ({
            key: survey.id,
            value: survey.id,
            text: survey.name,
          }))
        );
      } catch (error) {
        console.log(error);
      }
    };

    getData();
  }, [debouncedSearch]);

  return (
    <Container>
      <div>
        {!props?.noLabel && <Label>Selecione a pesquisa</Label>}
        <Dropdown
          placeholder="Busque pelo ID ou pelo nome da pesquisa"
          fluid
          search
          selection
          options={surveyOptions}
          onChange={(_, { value }) => onChangeSelectedSurveyID(value)}
          searchQuery={search}
          onSearchChange={(e) => handleChangeSearch(e.target.value)}
          value={selectedSurveyID}
          clearable
        />
      </div>
    </Container>
  );
}
